import { useEffect, useState } from 'react';
import { useRxCollection } from 'rxdb-hooks';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { RxdbCollectionName } from '../rxdbCollectionName';
import type { ViewInspectorCollection, ViewInspectorDocument } from './viewInspector.types';

export const useViewInspector = () => {
  const viewInspectorCollection: ViewInspectorCollection = useRxCollection(
    RxdbCollectionName.VIEW_INSPECTOR,
  );

  const [viewInspectorInitialized, setViewInspectorInitialized] = useState<boolean>(false);

  useEffect(() => {
    if (viewInspectorCollection) setViewInspectorInitialized(true);
  }, [viewInspectorCollection]);

  const getInspectorOnWorkPackage = async (
    workPackageId: number,
  ): Promise<ViewInspectorDocument[]> => {
    if (!viewInspectorCollection) return [];
    let viewInspector: ViewInspectorDocument[];
    try {
      viewInspector = await viewInspectorCollection
        ?.find({
          selector: {
            $and: [
              { workPackageId: { $eq: workPackageId } },
              { isActive: { $eq: true } },
              {
                $or: [{ fieldInspectorId: { $ne: null } }, { clerkId: { $ne: null } }],
              },
            ],
          },
        })
        .exec();
      return viewInspector;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(
        '🚀 ~ file: useviewInspector.ts ~ line 50 ~ getInspectorOnWorkPackage ~ error',
        error,
      );
      // console logs will be removed once sentry implementation is done
      sentryCaptureException(
        error,
        '~ file: useviewInspector.tsx ~ line 50 ~ getInspectorOnWorkPackage ~',
      );
      throw new Error(`error ${error}`);
    }
  };

  return {
    viewInspectorInitialized,
    viewInspectorCollection,
    getInspectorOnWorkPackage,
  };
};
